/*
 * @Descripttion:
 * @version:
 * @Author: linxi
 * @email: 2194421430@qq.com
 * @Date: 2023-06-07 14:19:49
 * @LastEditors: linxi
 * @LastEditTime: 2023-06-14 15:43:39
 */
import React, { useContext, useEffect, useState } from 'react'
import {
  Col,
  Form,
  Input,
  Modal,
  notification,
  Popover,
  Radio,
  Row,
  Space,
  Tag,
  Tooltip,
} from 'antd'
import { useDispatch, useSelector } from 'react-redux'
import { RootDispatch } from '../../app/store'
import styles from './Tenants.module.css'
import { unwrapResult } from '@reduxjs/toolkit'
import {
  getVersionChangeSubmitModal,
  getVersionManagementLit,

} from '../versionManagement/versionManagementSlice'
import { ThemeContext } from '../../theme/ThemeContext'

export const ChooseVersionModal = (props: {
  tenantIdList?: any
  versionId?: number
  visible: boolean
  onOk: () => void
  onCancel: () => void
  onChange: (v: any) => void
  onChangeId: (v: any) => void
}) => {
  const dispatch = useDispatch<RootDispatch>()

  const theme = useContext(ThemeContext)

  const [form] = Form.useForm()

  const [list, setList] = useState<any[]>([])

  const [selectKey, setSelectKey] = useState<any>()

  const [name, setName] = useState<any>()

  console.log(props?.versionId, props?.tenantIdList, 'versionId')


  useEffect(() => {
    if (props?.visible) {
      form.setFieldsValue({
        chooseBanben: Number(props?.versionId),
      })
    }
  }, [props?.versionId, props?.visible])

  const labelStyle = {
    style: {
      color: theme.tc1,
      fontSize: '14px',
      textAlign: 'left',
      marginBottom: 13,
    } as React.CSSProperties,
  }

  const titleStyle = {
    style: {
      color: theme.tc1,
      fontSize: '14px',
      textAlign: 'left',
      marginTop: 12,
    } as React.CSSProperties,
  }

  const valueStyle = {
    flex: 1,
    style: {
      color: theme.tc1,
      fontSize: '14px',
      marginBottom: 13,
      textAlign: 'left',
    } as React.CSSProperties,
  }

  useEffect(() => {
    if (props?.visible)
      dispatch(
        getVersionManagementLit({
          current: 1,
          size: 1000,
        })
      )
        .then(unwrapResult)
        .then((v: any) => {
          setList(
            v?.records?.map((v: any) => {
              return { ...v, labelList: v?.labels ? v?.labels?.split(',') : [] }
            })
          )
        })
  }, [props?.visible])

  return (
    <div>
      <Modal
        className={styles.chooseModal}
        title='版本选择'
        visible={props.visible}
        okText='确认'
        cancelText='取消'
        onOk={() => {
          props.onChange && props.onChange(name)
          props.onChangeId && props.onChangeId(selectKey || props?.versionId)

          form.resetFields()
          props.onOk()
        }}
        onCancel={() => {
          form.resetFields()
          props.onCancel()
        }}
        width='850px'
      >
        <Form
          name='dynamic_form_item'
          form={form}
          autoComplete='off'
          onFinish={(vs) => {
            form.resetFields()
            props.onOk()
          }}
        >
          <Form.Item
            name='chooseBanben'
            label=''
            rules={[
              {
                required: true,
              },
            ]}
          >
            <Radio.Group
              value={selectKey}
              defaultValue={Number(props?.versionId)}
              onChange={(v: any) => {
                const value = v.target.value
                console.log(value, '2222222222')
                const name = list?.filter((v) => {
                  return v?.id == value
                })?.[0]?.name
                setName(name)
                console.log(name, 'namenamename')
                setSelectKey(value)
              }}
            >
              {list?.map((v) => {
                return (
                  <>
                    <div style={{ width: '400px', marginBottom: '20px' }}>
                      <Popover
                        title={''}
                        content={
                          <div>
                            <Row className={styles.labelContent}>
                              <Col {...titleStyle}>标签：</Col>
                              <Col>
                                <Row className={styles.labels}>
                                  {v?.labelList?.map((i: any) => {
                                    return (
                                      <>
                                        <div className={styles.label}>{i} </div>
                                      </>
                                    )
                                  })}
                                </Row>
                              </Col>
                            </Row>
                            <Row gutter={20} style={{ marginLeft: '30px' }}>
                              {v?.versionPropertiesVOList?.map((b: any) => {
                                return (
                                  <>
                                    <Col span={12}>
                                      <Row>
                                        <Col {...labelStyle}>{b?.name}：</Col>
                                        {b?.name == '宣传图'
                                          ? b?.propValue && (
                                              <a href={b?.propValue}>查看</a>
                                            )
                                          : b?.propValue == 'true'
                                          ? '是'
                                          : b?.propValue == 'false'
                                          ? '否'
                                          : b?.propValue}
                                        <Col {...valueStyle}></Col>
                                      </Row>
                                    </Col>
                                  </>
                                )
                              })}
                            </Row>
                          </div>
                        }
                      >
                        <Radio value={v?.id}>{v?.name}</Radio>
                      </Popover>
                    </div>
                  </>
                )
              })}
            </Radio.Group>
          </Form.Item>
        </Form>
      </Modal>
    </div>
  )
}
